export default {
      id: "common__status_pin-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__status_pin",
      toString: function () {
        return this.url;
      }
    }